import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

const TAB_LABELS = ['Новые', 'Назначены', 'В работе', 'Завершены', 'Отменены'];

const QuestTabs = ({ tabValue, onTabChange }) => {
  const { currentTab, statusCounts } = useSelector((state) => state.quests);

  const activeTab = tabValue ?? currentTab;
  const counts = statusCounts ?? [0, 0, 0, 0, 0];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: '2px solid',
        borderColor: 'divider',
        px: 2,
        gap: 0,
      }}
    >
      {TAB_LABELS.map((label, i) => (
        <Box
          key={i}
          onClick={() => onTabChange && onTabChange(i)}
          sx={{
            px: 3,
            py: 1.5,
            cursor: 'pointer',
            position: 'relative',
            whiteSpace: 'nowrap',
            fontSize: '0.9rem',
            fontWeight: activeTab === i ? 600 : 400,
            color: activeTab === i ? 'primary.main' : 'text.secondary',
            borderBottom: activeTab === i ? '3px solid' : '3px solid transparent',
            borderColor: activeTab === i ? 'primary.main' : 'transparent',
            mb: '-2px',
            transition: 'all 0.2s',
            '&:hover': {
              color: 'primary.main',
              bgcolor: 'action.hover',
            },
          }}
        >
          {label}{' '}
          <Box
            component="span"
            sx={{
              fontWeight: 400,
              color: 'text.secondary',
              fontSize: '0.85em',
            }}
          >
            ({counts[i]})
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default QuestTabs;
